import { render, staticRenderFns } from "./actions-claim.vue?vue&type=template&id=bb75f8d4&"
import script from "./actions-claim.vue?vue&type=script&lang=js&"
export * from "./actions-claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports